import { IconButton, Modal, Tooltip, Typography } from "@mui/material";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import { useEffect, useState } from "react";
import { DataGrid, GridColumns } from "@mui/x-data-grid";
import StepLogsDataset from "../../data/StepLogsDataset";
import LogAlteracaoEtapa from "../../classes/LogAlteracaoEtapa";
import { useTranslation } from "react-i18next";
import { ptBR } from '@mui/x-data-grid/locales';

interface StepLogsHistoryProps {
  id: number;
  type: string;
  onClose: any;
}
interface Data {
  id: number;
  email: string;
  tipochave: string;
  descricao: string;
  criadoem: Date;
}

function StepLogsHistoryDetalhe(props: StepLogsHistoryProps) {
  const { t } = useTranslation();
  const [rows, setRows] = useState<Data[]>([]);
  const dataset: StepLogsDataset = new StepLogsDataset();
  const columns: GridColumns = [
    {
      field: "id",
      hide: true,
      headerName: "id",
      width: 80,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "criadoem",
      headerName: t("global.table.dateAndHour"),
      width: 150,
      align: "center",
      headerAlign: "center",
      renderCell: (props) =>
        new Date(props.row.criadoem).toLocaleString("pt-BR"),
    },
    {
      field: "email",
      headerName: t("global.table.user"),
      type: "string",
      width: 250,
      editable: false,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "descricao",
      headerName: t("global.table.description"),
      type: "string",
      flex: 1,
      editable: false,
      align: "center",
      headerAlign: "center",
    },
  ];

  useEffect(() => {
    setRows([]);
    dataset.get(props.id, props.type).then((result: LogAlteracaoEtapa[]) => {
      setRows(
        result.map((x, y) => {
          return {
            id: y + 1,
            criadoem: x.criadoEm,
            descricao: x.descricao,
            email: x.emailUsuario,
            tipochave: x.tipoChave,
          };
        })
      );
    });
  }, [props.id]);

  const getName = () => {
    switch (props.type) {
      case "ForecastMensal":
        return "Forecast Mensal";
      case "ForecastDiario":
        return "Forecast Diário";
      case "SolicitacaoMatPrima":
        return "Solicitação de Matéria Prima";
      case "LancamentoProducao":
        return "Lançamento de Produção";
      default:
        return props.type;
    }
  };

  return (
    <Modal
      open={true}
      onClose={props.onClose}
      sx={{
        display: "flex",
        "justify-content": "center",
        "align-items": "center",
      }}
    >
      <div
        className="containerForecastModal"
        style={{ width: "70vw", height: "80vh" }}
      >
        <div className="containerTitleModal">
          <Typography
            variant="h5"
            fontFamily={"Co Headline Regular"}
            gutterBottom
            align="left"
            marginLeft="15px"
          >
            {t("common.stepLogsHistoryDetalhe.modal.title", {
                id: props.id,
                name: getName()
            })}
          </Typography>
        </div>
        <div className="containerToolbarModal">
          <Tooltip title="Sair do Modal">
            <IconButton onClick={props.onClose}>
              <ExitToAppIcon />
            </IconButton>
          </Tooltip>
        </div>
        <div className="insiderContainerModal" style={{ height: "60vh" }}>
          <DataGrid
            rows={rows}
            columns={columns}
            rowsPerPageOptions={[50, 100, 250, 500]}
            disableSelectionOnClick
            localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
          />
        </div>
      </div>
    </Modal>
  );
}

export default StepLogsHistoryDetalhe;
